import { Bar } from 'react-chartjs-2';

import { formatMoney } from '../../utils/helpers/aiSpendFormat';
import { colorForKey, registerCharts } from './chartSetup';
import useChartTheme from './useChartTheme';

registerCharts();

export default function BarChart({
  labels,
  datasets,
  valueFormatter = formatMoney,
  stacked = false,
  horizontal = false,
  ariaLabel,
}) {
  const theme = useChartTheme();

  if (process.env.NODE_ENV !== 'production') {
    datasets.forEach((set) =>
      set.data.forEach((point) => {
        if (point !== null && !Number.isFinite(point)) {
          // eslint-disable-next-line no-console
          console.error(
            `Chart "${ariaLabel}" dataset "${set.label}": non-numeric data point`,
            point,
          );
        }
      }),
    );
  }

  const data = {
    labels,
    datasets: datasets.map((set, index) => ({
      label: set.label,
      data: set.data,
      backgroundColor: set.color || colorForKey(set.key, index),
      borderRadius: 4,
      type: set.type,
      borderColor: set.color || colorForKey(set.key, index),
      borderWidth: set.type === 'line' ? 2 : 0,
      pointRadius: 0,
    })),
  };

  const valueAxis = {
    stacked,
    ticks: { color: theme.tick, callback: (value) => valueFormatter(value) },
    grid: { color: theme.grid },
  };
  const categoryAxis = {
    stacked,
    ticks: { color: theme.tick },
    grid: { display: false },
  };

  const options = {
    indexAxis: horizontal ? 'y' : 'x',
    responsive: true,
    maintainAspectRatio: false,
    resizeDelay: 120,
    plugins: {
      legend: {
        display: datasets.length > 1,
        labels: { color: theme.tick, boxWidth: 10 },
      },
      tooltip: {
        ...theme.tooltip,
        callbacks: {
          label: (context) =>
            `${context.dataset.label}: ${valueFormatter(
              horizontal ? context.parsed.x : context.parsed.y,
            )}`,
        },
      },
    },
    scales: horizontal
      ? { x: valueAxis, y: categoryAxis }
      : { x: categoryAxis, y: valueAxis },
  };

  return (
    <Bar
      key={theme.isDark ? 'dark' : 'light'}
      data={data}
      options={options}
      role="img"
      aria-label={ariaLabel}
    />
  );
}
